/* eslint-disable func-names, max-len */
import 'jquery-match-height';

const setupThinWidgets = function () {
  $('.promo-pops__thin').each(function () {
    const height = $(this).find('img').height();
    $(this).css('height', height);
  });
};
$(window).resize(() => {
  setupThinWidgets();
});

setTimeout(() => {
  $('.promo-pops__large').each(function () {
    $(this).find('.match-height').matchHeight();
  });

  setupThinWidgets();
}, 500);

const $countdownSection = $('.promo-pops__large .promo-pops__display-timer, .promo-pops__thin .promo-pops__display-timer');
if ($countdownSection.length > 0) {
  /* Return the given number left-padded with zeroes to reach the required length */
  const padLeft = function (number, padTo) {
    number = number.toString();
    while (number.length < padTo) {
      number = `0${number}`;
    }

    return number;
  };

  $(document).ready(() => {
    $countdownSection.each(function () {
      const $countdown = $(this);

      const $dateField = $countdown.find("input[id$='hdnEndDateTime']");

      if ($dateField.length > 0) {
        setInterval(() => {
          const endDateTime = new Date(parseInt($dateField.val(), 10));

          // Total time beteen the dates in seconds
          let remainder = Math.abs(endDateTime - new Date()) / 1000;

          // Remove the countdown section when the timer reaches zero
          if (remainder < 0) {
            $countdown.remove();
          }

          // Remaining time in days
          const days = Math.floor(remainder / 86400);
          remainder -= days * 86400;

          // Remaining time in hours
          const hours = Math.floor(remainder / 3600) % 24;
          remainder -= hours * 3600;

          // Remaining time in minutes
          const minutes = Math.floor(remainder / 60) % 60;
          remainder -= minutes * 60;

          // Remaining time in seconds
          const seconds = Math.floor(remainder % 60);

          $countdown.find('.days span').text(days);
          $countdown.find('.hours span').text(padLeft(hours, 2));
          $countdown.find('.minutes span').text(padLeft(minutes, 2));
          $countdown.find('.seconds span').text(padLeft(seconds, 2));
        }, 1000);
      } else {
        $countdown.remove();
      }
    });
  });
}
